import { render, staticRenderFns } from "./MerchantManager.vue?vue&type=template&id=608708cd&scoped=true"
import script from "./MerchantManager.vue?vue&type=script&lang=js"
export * from "./MerchantManager.vue?vue&type=script&lang=js"
import style0 from "./MerchantManager.vue?vue&type=style&index=0&id=608708cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608708cd",
  null
  
)

export default component.exports